import React from "react";
import "./Loader.css"
const Loader = () => {
  return (
    <div className="overlay-bg">
      <img src={`${process.env.PUBLIC_URL}/images/loader.gif`} id="loaderfav" alt="Loader Icon" />
    </div>
  );
};

export default Loader;
